/**
 * Single source of truth for every piece of business data that used to be
 * duplicated across Header, Footer, Contact, FloatingContactButtons and the
 * chatbot. Change it here and it changes everywhere.
 */

export const company = {
  name: "Devanshi Corporation",
  shortName: "Devanshi",
  tagline: "Industrial chemicals, sourced with precision",
  established: 2000,
  ceo: "Paras Pandya",
  legalStatus: "Proprietorship",
  gst: "27AAEHP0870M1ZU",
  business: "Importer · Wholesaler · Distributor",

  email: "devanshicorporation@gmail.com",

  phones: {
    office: { label: "Office", display: "+91 99208 50545", tel: "+919920850545" },
    whatsapp: { label: "WhatsApp", display: "+91 98213 41221", tel: "+919821341221" },
    landline: { label: "Landline", display: "+91 22 3555 0545", tel: "+912235550545" },
  },

  whatsappMessage: "Hello! I would like to know more about your industrial chemicals.",

  address: {
    lines: [
      "215, Reena Complex, Ramdev Pir Road",
      "Opp. Neelkanth Business Park",
      "Vidyavihar West, Mumbai 400086",
    ],
    city: "Mumbai",
    state: "Maharashtra",
    country: "India",
    postalCode: "400086",
    full: "215, Reena Complex, Ramdev Pir Road, Opp. Neelkanth Business Park, Vidyavihar West, Mumbai, Maharashtra 400086, India",
    mapsQuery: "Reena+Complex+Ramdev+Pir+Road+Vidyavihar+West+Mumbai+400086",
  },

  banks: ["Union Bank of India", "SVC Co-operative Bank Ltd"],
  payments: ["Cash", "Cheque", "Demand Draft", "Credit Card", "Online Transfer", "RTGS / NEFT"],
  shipping: ["By Road", "By Sea", "By Air", "By Cargo"],

  hours: [
    { days: "Monday to Saturday", time: "10:00 to 19:00 IST" },
    { days: "Sunday", time: "Closed" },
  ],
};

export const whatsappUrl = `https://wa.me/${company.phones.whatsapp.tel.replace(
  "+",
  ""
)}?text=${encodeURIComponent(company.whatsappMessage)}`;

export const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${company.address.mapsQuery}`;

export const stats = [
  { value: 25, suffix: "+", label: "Years importing", detail: "Trading since 2000" },
  { value: 500, suffix: "+", label: "Clients served", detail: "Across India" },
  { value: 11, suffix: "", label: "Core compounds", detail: "In active stock" },
  { value: 10, suffix: "+", label: "Industries served", detail: "Agri to fire safety" },
];

export const capabilities = [
  {
    index: "01",
    title: "Global sourcing",
    body: "Direct import relationships with verified manufacturers, so grade and purity are locked in at origin, not guessed at on arrival.",
  },
  {
    index: "02",
    title: "Quality assurance",
    body: "Every consignment lands with its certificate of analysis. Batch identity, purity and moisture are traceable from vessel to your gate.",
  },
  {
    index: "03",
    title: "Warehousing & logistics",
    body: "Mumbai-based bonded and dry storage with dispatch by road, sea, air and cargo, for pan-India delivery on committed timelines.",
  },
  {
    index: "04",
    title: "Custom procurement",
    body: "Need a grade we do not stock? We run the search, vet the supplier and handle the documentation end to end.",
  },
];

export const industries = [
  "Agriculture & Fertilizers",
  "Glass Manufacturing",
  "Pharmaceuticals",
  "Food Processing",
  "Water Treatment",
  "Metal Finishing",
  "Refractories",
  "Animal Feed",
  "Rubber & Polymers",
  "Fire Safety",
];

export const milestones = [
  { year: "2000", title: "Founded in Mumbai", body: "Devanshi Corporation opens as a proprietorship trading industrial salts." },
  { year: "2008", title: "Direct imports begin", body: "First direct manufacturer relationships replace the local broker chain." },
  { year: "2015", title: "Humic range added", body: "Agricultural humates and fulvates join the catalogue for the fertilizer sector." },
  { year: "2020", title: "Two decades in", body: "500+ industrial clients served across agriculture, glass, pharma and feed." },
  { year: "2026", title: "Scaling the network", body: "Eleven compounds held in continuous stock for pan-India dispatch." },
];
